"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMockTestType = void 0;
var EMockTestType;
(function (EMockTestType) {
    EMockTestType[EMockTestType["ALL"] = 0] = "ALL";
    EMockTestType[EMockTestType["FINALS"] = 1] = "FINALS";
    EMockTestType[EMockTestType["PSA"] = 2] = "PSA";
    EMockTestType[EMockTestType["MISCELLANEOUS"] = 3] = "MISCELLANEOUS";
    EMockTestType[EMockTestType["UNIVERSITY_SPECIFIC"] = 4] = "UNIVERSITY_SPECIFIC";
    EMockTestType[EMockTestType["ANATOMY_SPOTTER"] = 5] = "ANATOMY_SPOTTER";
    EMockTestType[EMockTestType["UKMLA"] = 6] = "UKMLA";
    EMockTestType[EMockTestType["MRCP"] = 7] = "MRCP";
    EMockTestType[EMockTestType["UKMLA_FULL"] = 8] = "UKMLA_FULL";
    EMockTestType[EMockTestType["FULL_MOCK"] = 9] = "FULL_MOCK";
    EMockTestType[EMockTestType["VERBAL_REASONING"] = 10] = "VERBAL_REASONING";
    EMockTestType[EMockTestType["DECISION_MAKING"] = 11] = "DECISION_MAKING";
    EMockTestType[EMockTestType["QUANTITATIVE_REASONING"] = 12] = "QUANTITATIVE_REASONING";
    EMockTestType[EMockTestType["SITUATIONAL_JUDGEMENT"] = 13] = "SITUATIONAL_JUDGEMENT";
})(EMockTestType = exports.EMockTestType || (exports.EMockTestType = {}));
